/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider } from "@mui/material";
import { AnswerState } from "../../Context/questionsContext";
import AnswerRows from "./AnswerRows";

type AnswersRowsProps = {
  answerType: string;
  answers: Array<AnswerState>;
  saveQuestionnaires: (e: any) => void;
};
export default function AnswersRows(props: AnswersRowsProps) {
  const { answers, answerType, saveQuestionnaires } = props;

  return (
    <>
      {answers.map((answer, index) => (
        <>
          <AnswerRows
            answerNumber={index}
            answerType={answerType}
            answer={answer}
            answers={answers}
            saveQuestionnaires={saveQuestionnaires}
          />
          <Divider />
        </>
      ))}
    </>
  );
}
